import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';


@Component({
    // tslint:disable-next-line:component-selector
    selector: 'btn-closecell-renderer',
    template: `
    <button mat-mini-fab color="primary" (click)="onClick($event)"  tooltipPosition="top"  pTooltip="Edit Waste">
    <mat-icon>edit</mat-icon>
  </button>`
})
// tslint:disable-next-line:component-class-suffix
export class BtnCellRendererWasteReworkHistory implements ICellRendererAngularComp, OnDestroy {
    params: any;
    agInit(params: any): void {
        this.params = params;
  
    }
    onClick($event: any): any {
        if (this.params.onClick instanceof Function) {
            // put anything into params u want pass into parents component
            const params = {
                event: $event,
                rowData: this.params.node.data
                // ...something
            };
            this.params.onClick(params);
        }
    }
    ngOnDestroy(): any {
        // no need to remove the button click handler
        // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
    }

    refresh(): boolean {
        return true;
    }
}
